import { Provider } from '@angular/core';
import { EjournalEntriesService } from './services/ejournal-entries.service';
import { EjournalFinalizeService } from './services/ejournal-finalize.service';
import { EjournalLoadService } from './services/ejournal-load.service';
import { EjournalPacketPdfService } from './services/ejournal-packet-pdf.service';
import { EjournalSealsService } from './services/ejournal-seals.service';
import { EjournalSessionCancelService } from './services/ejournal-session-cancel.service';
import { EjournalSignersService } from './services/ejournal-signers.service';
import { EjournalService } from './services/ejournal.service';

/** Session-scoped providers for an eJournal dashboard / details host. */
export const EJOURNAL_SESSION_PROVIDERS: Provider[] = [
  EjournalSessionCancelService,
  EjournalEntriesService,
  EjournalSignersService,
  EjournalSealsService,
  EjournalLoadService,
  EjournalFinalizeService,
  EjournalPacketPdfService,
  EjournalService,
];
